"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepConnector = void 0;
var core_1 = require("@material-ui/core");
exports.StepConnector = core_1.withStyles({
    root: {
        maxWidth: '24px',
    },
    line: {
        display: 'none',
        borderColor: 'none',
        borderTopWidth: 0,
        borderRadius: 0,
    },
})(core_1.StepConnector);
